import React from 'react';
import ImageButtonList from '../common/imageButtonList';
import ImageText from '../common/imageText';
import correctPopup from './images/Popup_Correct.png';
import incorrectPopup from './images/Popup_Incorrect.png';
import continueHL from './images/Popup_Correct_Continue_HL.png';
import continueUH from './images/Popup_Correct_Continue_UH.png';
import viewAgainHL from './images/Popup_Incorrect_ViewVideo_HL.png';
import viewAgainUH from './images/Popup_Incorrect_ViewVideo_UH.png';

export const CorrectPopupType = 'correctPopupType';
export const IncorrectPopupType = 'incorrectPopupType';

export default class AnswerPopup extends React.Component {
  /**************
   * Properties *
   **************/
  state = {
    [CorrectPopupType]: [{
      id: 'continue',
      to: this.props.continueLink,
      highlight: continueHL,
      unhighlight: continueUH,
      alt: 'Continue'
    }],
    [IncorrectPopupType]: [{
      id: 'continue',
      to: this.props.continueLink,
      highlight: continueHL,
      unhighlight: continueUH,
      alt: 'Continue'
    }, {
      id: 'viewAgain',
      to: this.props.viewAgainLink,
      highlight: viewAgainHL,
      unhighlight: viewAgainUH,
      alt: 'View Again'
    }]
  };

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns { React.Component }  The rendered view of the component.
   *
   */
  render() {
    return (
      <div className={(this.props.type === CorrectPopupType) ? "correct-popup" : "incorrect-popup"}>
        <ImageText src={(this.props.type === CorrectPopupType) ? correctPopup : incorrectPopup} />
        <ImageButtonList imageButtons={this.state[this.props.type]} />
      </div>
    );
  }
}
